import React, { useEffect, useState } from "react";
import SubNav from "./SubNav";
import AdminTools from "../AdminTools/AdminTools";
import { Button, Collapse, Container, Alert } from "react-bootstrap";
import { useAuth } from "../../firebaseContext";
import Footer from "./Footer";

const ADMIN_SECTION_KEY = "nca-admin-actions-open";
const ANNOUNCEMENT_EXPIRY = new Date("2025-10-31T00:00:00+11:00").getTime();

export default function Dashboard() {
  const { admin } = useAuth();
  const [showAdmin, setShowAdmin] = useState(() => {
    if (typeof window === "undefined") {
      return true;
    }
    const stored = window.localStorage.getItem(ADMIN_SECTION_KEY);
    if (stored === null) {
      return true;
    }
    return stored === "true";
  });
  const [announcementActive, setAnnouncementActive] = useState(
    () => Date.now() < ANNOUNCEMENT_EXPIRY
  );

  useEffect(() => {
    const suppressContext = (event) => event.preventDefault();
    document.addEventListener("contextmenu", suppressContext);
    return () => document.removeEventListener("contextmenu", suppressContext);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    window.localStorage.setItem(
      ADMIN_SECTION_KEY,
      showAdmin ? "true" : "false"
    );
  }, [showAdmin]);

  useEffect(() => {
    if (!announcementActive) {
      return;
    }

    const now = Date.now();
    if (now >= ANNOUNCEMENT_EXPIRY) {
      setAnnouncementActive(false);
      return;
    }

    const timeout = setTimeout(() => {
      setAnnouncementActive(false);
    }, ANNOUNCEMENT_EXPIRY - now);

    return () => clearTimeout(timeout);
  }, [announcementActive]);

  return (
    <>
      {admin && (
        <section className="py-5 bg-light">
          <Container fluid="lg">
            <div className="d-flex justify-content-end mb-4">
              <Button
                variant={showAdmin ? "outline-primary" : "primary"}
                onClick={() => setShowAdmin((prev) => !prev)}
                className="rounded-pill fw-semibold px-4"
              >
                {showAdmin ? "Hide admin actions" : "Show admin actions"}
              </Button>
            </div>
            <Collapse in={showAdmin}>
              <div>
                <AdminTools />
              </div>
            </Collapse>
          </Container>
        </section>
      )}
      {announcementActive && (
        <section className="dashboard-announcement py-4">
          <Container fluid="lg">
            <Alert
              variant="primary"
              className="dashboard-announcement-alert mb-0"
            >
              <div className="dashboard-announcement-content">
                <div className="dashboard-announcement-heading">
                  Site Wide UI/UX updated!
                </div>
                <div className="dashboard-announcement-copy">
                  If there are any issues, report to <strong>IT Support</strong>{" "}
                  on MS Teams.
                </div>
              </div>
            </Alert>
          </Container>
        </section>
      )}
      <SubNav />
      <Footer />
    </>
  );
}
